// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { App } from './components/app';
import config, { loadConfig } from './environments/environment';
import { InitClarity } from './components/clarity';

(async () => {
    await loadConfig();
    if (config.clarityTag) {
        InitClarity(config.clarityTag);
    }
    ReactDOM.render(<App />, document.getElementById('root'));
})();
